// UserGeneralDetailsComponent.ts
import {CommonModule, NgClass} from '@angular/common';
import {Component, inject, input} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {AutoTabIndexDirective} from '@shared/ui';
import {FormControlCollectorDirective} from '../../../directives/form-control-collector.directive';
import {UserFormFactory} from '../../../services/user-form.factory';
import {UserFormErrorComponent} from '../components/user-form-error.component';
import {CommunicationPreference} from '../../../models/user-form.model';
@Component({
	selector: 'dc-user-form-contact-information',
	styleUrls: ['../user-form.styles.scss'],
	imports: [ReactiveFormsModule, AutoTabIndexDirective, CommonModule, NgClass, FormControlCollectorDirective, TranslateModule, UserFormErrorComponent],
	template: `
		<div
			class="section-fields-container"
			[formGroup]="parentForm()"
		>
			<!-- Email -->
			<div class="form-field-container">
				<label for="email">
					{{ 'user.form.field.email' | translate }}
				</label>
				<input
					id="email"
					type="email"
					formControlName="email"
					[ngClass]="{'error-input': isInvalid('email')}"
					autocomplete="email"
					autoTabIndex
				/>
				<dc-user-form-error
					[parentForm]="parentForm()"
					controlSection="ContactInfo"
					controlName="email"
					[isInvalidFn]="isInvalid"
				/>
			</div>
			<!-- Phone Number -->
			<div class="form-field-container">
				<label for="phonenumber">
					{{ 'user.form.field.phonenumber' | translate }}
				</label>
				<input
					id="phonenumber"
					type="tel"
					formControlName="phonenumber"
					[ngClass]="{'error-input': isInvalid('phonenumber')}"
					autocomplete="tel"
					autoTabIndex
				/>
				<dc-user-form-error
					[parentForm]="parentForm()"
					controlSection="ContactInfo"
					controlName="phonenumber"
					[isInvalidFn]="isInvalid"
				/>
			</div>
			<div class="form-field-container">
				<label
					for="communication-preferences"
					class="communication-preferences font-semibold -mx-1"
					>{{ 'user.form.field.communicationPreference.label' | translate }}</label
				>
				<div class="options-container">
					<div class="option-item">
						<input
							id="comm-none"
							type="radio"
							formControlName="communicationPreference"
							name="communicationPreference"
							[value]="CommunicationPreference.none"
							autoTabIndex
						/>
						<label for="comm-none">
							{{ 'user.form.field.communicationPreference.none' | translate }}
						</label>
					</div>
					<div class="option-item">
						<input
							id="comm-email"
							type="radio"
							formControlName="communicationPreference"
							[value]="CommunicationPreference.notifyEmail"
							autoTabIndex
						/>
						<label for="comm-email">
							{{ 'user.form.field.communicationPreference.email' | translate }}
						</label>
					</div>
					<div class="option-item">
						<input
							id="comm-sms"
							type="radio"
							formControlName="communicationPreference"
							[value]="CommunicationPreference.notifySMS"
							autoTabIndex
						/>
						<label for="comm-sms">
							{{ 'user.form.field.communicationPreference.sms' | translate }}
						</label>
					</div>
					<div class="option-item">
						<input
							id="comm-whatsapp"
							type="radio"
							formControlName="communicationPreference"
							[value]="CommunicationPreference.notifyWhatsapp"
							autoTabIndex
						/>
						<label for="comm-whatsapp">
							{{ 'user.form.field.communicationPreference.whatsapp' | translate }}
						</label>
					</div>
				</div>
				<!-- Error Message for Radio Group -->
				<dc-user-form-error
					[parentForm]="parentForm()"
					controlSection="ContactInfo"
					controlName="communicationPreference"
					controlNameLabel="user.form.field.communicationPreference.label"
					[isInvalidFn]="isInvalid"
				/>
			</div>
		</div>
	`,
})
export class UserFormContactInformationComponent {
	protected readonly CommunicationPreference = CommunicationPreference;
	private readonly userFormFactory = inject(UserFormFactory);
	protected readonly isInvalid = this.userFormFactory.isInvalidFnFactory<'ContactInfo'>({checkDirty: false});
	readonly parentForm = input.required<FormGroup>();
}
